<div class="container mx-auto lg:pt-8 sm:pt-4 px-4 md:px-0 bg-white">
  <div class="">
    <h2 class=" font-noto-serif text-center text-2xl md:text-3xl font-semibold text-[var(--dark-teal)]
             mb-6 md:mb-10">
      Item Categories
    </h2>

    <!-- Mobile: 1 col; sm: 2; lg: 4 -->
    <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-y-8 sm:gap-y-10 gap-x-8  mt-4 ">
      <button *ngFor="let c of categories; trackBy: trackByLabel" pButton type="button" (click)="go(c)"
        [attr.aria-label]="c.label" class="group relative flex flex-col items-center p-3
                 " pRipple>
        <img [src]="c.src" [alt]="c.label" class="h-24 w-24 md:h-28 md:w-28 object-contain
           transition-transform duration-200 group-hover:scale-110
           motion-reduce:transition-none motion-reduce:transform-none" />
        <span class="mt-3 text-[15px] md:text-xl font-medium text-[var(--dark-teal)]">{{ c.label }}</span>
      </button>


    </div>
  </div>
</div>